/**
 * Blueprint for an accordion item.
 * @param {string} id id
 * @param {string} title title
 * @return {{id, title}} returns id and title
 * @constructor
 */
const AccordionItem = function(id, title) {
  return {
    id,
    title
  };
};

export default AccordionItem;
